/** Registered backend plugin id; action ids use `rithum-agent:<action-name>`. */
export const RITHUM_AGENT_PLUGIN_ID = 'rithum-agent';

export const RITHUM_AGENT_START_TASK_ACTION_NAME = 'start-task';

/** Full Actions Registry id: `pluginId:actionName`. */
export const RITHUM_AGENT_START_TASK_ACTION_ID = `${RITHUM_AGENT_PLUGIN_ID}:${RITHUM_AGENT_START_TASK_ACTION_NAME}`;
